
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/technology",
      function () {
        return require("private-next-pages/event/technology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/technology"])
      });
    }
  